import React from "react";
import {
  Card,
  Row,
  Button,
} from "react-bootstrap";
import "react-multiple-select-dropdown-lite/dist/index.css";
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { MySelect } from "../../ui/controls/MySelect";
import { getRoomCategoryList } from "../../../store/slices/catalogue/thunks";
import { MyDatePicker } from "../../ui/controls/MyDatePicker";

export const FormSearchRoomCategory = () => {
  const dispatch = useDispatch();
  const { hotelsList } = useSelector((state) => state.general);

  return (
    <div>

      <Row>
        <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12">
          <Card>
            <Card.Header>
              <h4 className="card-title">Buscar Categorías de Habitacion</h4>
            </Card.Header>
            <Card.Body>
              <Formik
                initialValues={{
                  hotel: {value:0, label:"Seleccione un hotel"},
                }}
                onSubmit={(({ hotel },
                  { resetForm, setErrors }) => {

                  if (hotel.value === 0) {
                    return setErrors({ "hotel": "Requerido" })
                  }

                  dispatch(getRoomCategoryList(hotel.value));
                })}
                validationSchema={
                  Yup.object({
                  })
                }
              >

                {
                  ({ setFieldValue }) => (
                    <Form>
                      <Row>
                        <div className="col-lg-6 col-md-12">
                          <div className=" row mb-6">
                            <MySelect label='Por hotel:' name="hotel" options={[{ value: 0, label: "Seleccione un hotel" }, ...hotelsList]} mode='horizontal'
                              singleSelect="true"
                              onChange={e => {
                                setFieldValue("hotel", e);
                              }} />
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-12">
                          <div className=" row mb-4">
                            <Button variant="primary" type="submit">
                              Buscar
                            </Button>
                          </div>
                        </div>
                      </Row>
                    </Form>
                  )
                }
              </Formik>
            </Card.Body>
          </Card>
        </div>
      </Row>
    </div>
  );
}
